import bg from './bg';
import en from './en';

let texts = bg;

export {
    texts
}